import { CommonImageKeys } from "src/contexts/_shared/domain/ImageKeys";

export const useCommonImages = (key: CommonImageKeys) => {
  return `https://cdn.permisso.io/widget/common/${key}`;
};
